import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <article className="relative h-[70vh]">
      <div className="absolute w-full h-full">
        <img src="/assets/hero.png" alt="Hero" className="w-full h-full" />
      </div>
      <div className="relative z-10 w-full h-full bg-black/50 ">
        <div className="flex flex-col justify-center w-11/12 h-full gap-8 mx-auto">
          <section className="text-white font-bold  max-w-[800px]">
            <h1 className=" text-[20px] md:text-[40px]">
              {t("Global Logistics Solutions")}
            </h1>
            <p className="text-[16px] md:text-[24px]">{t("18Years")} </p>
          </section>
          <section className="flex items-center gap-4 text-[16px] md:text-[20px] font-bold">
            <Link
              to={"/services"}
              className="px-4 py-2 text-white rounded-lg md:px-8 md:py-4 bg-mainRed hover:bg-mainRed/90"
            >
              {t("ourServices")}
            </Link>
            <Link
              to={"/contact-us"}
              className="px-4 py-2 text-white rounded-lg md:px-8 md:py-4 bg-mainBlue hover:bg-mainBlue/90"
            >
              {t("contactUs")}
            </Link>
          </section>
        </div>
      </div>
    </article>
  );
};

export default Hero;
